<template>
    <div
        :v-bind="slide.id"
        :class="`slide ${slide.type}`"
    >
        <div
            class="scroll"
            style="max-width: 100vw; overflow-x: hidden;"
        >
            <h1
                v-if="index === 0"
                style="margin-top: 15px; padding: 0 10px;"
            >{{ unit.name }}</h1>
            <f7-block
                v-if="index === 0"
                style="margin-top: 0px"
            >
                <div
                    class="description"
                    v-html="unit.description"
                />
                <br v-if="unit.id === 285">
                <div
                    v-if="slide.attachments && slide.attachments[0] && slide.attachments[0].type !== 'image'"
                    class="wave postDesc"
                />
                <template v-if="index === 0 && unit.hasVersions">
                    <h5
                        style="padding: 0 16px;"
                        @click="versionSelector"
                    ><i class="ion-android-funnel" />&nbsp;&nbsp;Version: {{ unit.versionName }}</h5>
                </template>
                <h5
                    v-if="unit.players === 2"
                    style="padding: 0 16px;"
                ><i class="ion-person-stalker" />&nbsp;&nbsp;Partner exercise</h5>
                <template v-if="index === 0 && unit.type === 'post' && unit.data && unit.data.authorName">
                    <h5 style="padding: 0 16px;">Posted by {{ unit.data.authorName }}</h5>
                </template>
            </f7-block>
            <br
                v-else
                slot="line-height: 40px"
            >

            <h2
                v-if="slide.type === 'summary'"
                class="greenTitle"
            >Key takeaways</h2>
            <svg
                v-if="slide.type === 'summary'"
                class="wavies-container"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 24 150 28"
                preserveAspectRatio="none"
            >
                <defs>
                    <path
                        id="gentle-wave"
                        d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                    />
                </defs>
                <g class="wavies">
                    <use
                        xlink:href="#gentle-wave"
                        x="50"
                        y="0"
                        fill="#e3e3e3"
                    />
                    <use
                        xlink:href="#gentle-wave"
                        x="50"
                        y="3"
                        fill="#D7CAC2"
                    />
                    <use
                        xlink:href="#gentle-wave"
                        x="50"
                        y="6"
                        fill="#ff6e61"
                    />
                </g>
            </svg>
            <div class="mainSlideContent">

                <template v-for="(attach, attachIndex) in slide.attachments">
                    <template v-if="attachIndex > 0 && attach.type === 'text' && slide.attachments[attachIndex - 1].type === 'text'">
                        <div
                            :key="`attach-ball-${attach.id}`"
                            class="wave"
                        />
                        <!-- :class="`balls ball${((attachIndex % 2) === 0) ? '3' : '2'}`" -->
                    </template>

                    <template v-if="attach.type === 'text' && !attach.root">
                        <div
                            v-if="attach.title"
                            :class="`html padded ${slide.type}`"
                            :key="`attach-text-${attach.id}`"
                            v-html="renderText(attach.title)"
                        />
                    </template>
                    <template v-if="attach.type === 'text' && attach.root">
                        <!-- remove if striped of tags no content as root is always there -->
                        <div
                            v-if="slide.text && slide.text.replace(/<[^>]*>?/gm, '').length > 2 && slide.text.replace(/<[^>]*>?/gm, '') !== 'New slide'"
                            :class="`html padded ${slide.type}`"
                            :key="`attach-text-${attach.id}`"
                            v-html="renderText(slide.text)"
                        />
                    </template>
                    <template v-if="attach.type === 'answer'">
                        <answer
                            :attach="attach"
                            :slide="slide"
                            :key="`attach-${attach.id}`"
                        />
                    </template>
                    <template v-if="attach.type === 'question'">
                        <question
                            :attach="attach"
                            :slide="slide"
                            :unit="unit"
                            :index="index"
                            :key="`attach-${attach.id}`"
                        />
                    </template>
                    <template v-if="attach.type === 'image'">
                        <img
                            v-if="attach.data && attach.data.hasImage"
                            :src="attach.data.imageUrl"
                            :key="`attach-${attach.id}`"
                            :style="attach.data.imageWidth ? `max-width: ${attach.data.imageWidth}px;` : ''"
                            class="slideImg"
                        >
                    </template>
                    <template v-if="attach.type === 'audio'">
                        <br :key="`attach-${attach.id}-br`">
                        <audio-player
                            v-if="attach.data.audioUrl"
                            :sources="[attach.data.audioUrl]"
                            :volume="1"
                            :loop="false"
                            :attach="attach"
                            :unit="unit"
                            :html5="true"
                            :url="`/units/${unit.id}?page=${index}`"
                            :key="`attach-${attach.id}`"
                            :color="currentCourse && coursesIndex[currentCourse.id] && topicsIndex[currentCourse.topicId] ? topicsIndex[currentCourse.topicId].color : false"
                        />

                        <!-- <a
                            v-if="unit.type === 'story'"
                            :key="`attach-${attach.id}-4`"
                            style="clear: both; display: inline-block; margin-top: 20px"
                            href="/submitStory"
                        >Have a story to share?</a>
                        <span
                            v-if="unit.type === 'story' && attach.data.transcript && attach.data.transcript.length > 32"
                            :key="`attach-${attach.id}-int`"
                        > - </span> -->
                        <!-- <template v-if="attach.data.transcript && attach.data.transcript.length > 32">
                            <a
                                :key="`attach-${attach.id}-5`"
                                style="display: inline-block; margin-top: 20px; font-size: 16px;"
                                href="#"
                                @click="showTranscript = !showTranscript; trackShowTranscript();"
                            >{{ showTranscript ? 'Hide transcript' : 'Show transcript' }}</a>
                        </template>
                        <f7-block
                            v-if="showTranscript"
                            :key="`attach-${attach.id}-6`"
                            class="html padded"
                            style="padding-top: 15px"
                            v-html="attach.data.transcript"
                        /> -->
                    </template>
                    <template v-if="attach.type === 'video'">
                        <br :key="`attach-${attach.id}-br`">
                        <video-player
                            v-if="attach.data.videoUrl"
                            :attach="attach"
                        />
                    </template>
                    <template v-if="attach.type === 'custom'">
                        <custom
                            :attachment="attach"
                            :key="`attach-${attach.id}`"
                        />
                    </template>
                    <template v-if="attach.type === 'graph' && attach.data.answers">
                        <graph
                            :attach="attach"
                            :slide="slide"
                            :key="`attach-${attach.id}`"
                        />
                    </template>
                    <!-- <span v-if="attach.data.answers && attach.myAnswer && attach.data.answers[attach.myAnswer.choiceInt]" style="color: lightgray" :key="`attach-${attach.id}-ans`">You said "{{attach.data.answers[attach.myAnswer.choiceInt].title}}"</span>
                <span v-if="attach.data.min && attach.myAnswer" style="color: lightgray" :key="`attach-${attach.id}-ans`">You said "{{attach.myAnswer.choiceInt}}"</span> -->
                </template>
            </div>
            <svg
                v-if="slide.type === 'summary'"
                class="wavies-container rotate"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 24 150 28"
                preserveAspectRatio="none"
            >
                <defs>
                    <path
                        id="gentle-wave"
                        d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                    />
                </defs>
                <g class="wavies">
                    <use
                        xlink:href="#gentle-wave"
                        x="50"
                        y="-1"
                        fill="#e3e3e3"
                    />
                    <use
                        xlink:href="#gentle-wave"
                        x="50"
                        y="3"
                        fill="#D7CAC2"
                    />
                    <use
                        xlink:href="#gentle-wave"
                        x="50"
                        y="6"
                        fill="#FF6E61"
                    />
                </g>
            </svg>
            <f7-block>
                <div class="ansButtons ">
                    <template v-if="slide.type === 'quizend'">
                        <f7-button
                            color="red"
                            fill
                            round
                            @click="restartUnit()"
                        >REDO QUIZ</f7-button>
                        <f7-button
                            color="red"
                            fill
                            round
                            @click="shareResult()"
                        >SHARE MY RESULT</f7-button>
                    </template>
                    <template v-if="index === unit.slides.length - 1">
                        <f7-button
                            v-if="unit.id !== 285"
                            :class="`complete`"
                            color="red"
                            fill
                            round
                            @click="complete(true, false)"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="13"
                                viewBox="0 0 19 13"
                                style="margin-right: 30px"
                            >
                                <polyline
                                    fill="none"
                                    stroke="#fff"
                                    stroke-width="2"
                                    points="39 35.226 43.387 39.613 56 27"
                                    transform="translate(-38 -27)"
                                />
                            </svg>
                            COMPLETE</f7-button>
                    </template>
                    <template v-else>
                        <f7-button
                            v-if="!slideLastAttachHasButtons()"
                            color="red"
                            fill
                            round
                            @click="nextSlide()"
                        >CONTINUE</f7-button>
                    </template>
                </div>
            </f7-block>
            <br><br><br><br>
        </div>
    </div>
</template>

<script>
// app.navbar.initNavbarOnScroll(page.el, $navbarInnerEl[0], needHideOnScrollHandler, needCollapseOnScrollHandler);
// import _ from 'lodash';

import AudioPlayer from './attachments/audioPlayer.vue';
import VideoPlayer from './attachments/videoPlayer.vue';
import Custom from './attachments/custom.vue';
import Answer from './attachments/answer.vue';
import Graph from './attachments/graph.vue';
import Question from './attachments/question.vue';

import utils from '../js/utils';
import {
    BEGIN_THE_REVOLUTION,
    CHANGE_YOUR_LIFE_IDS,
    DESIRE_TYPE
} from '../js/constants';


export default {
    components: {
        AudioPlayer,
        VideoPlayer,
        Answer,
        Graph,
        Question,
        Custom
    },
    props: ['slide', 'id', 'index', 'total', 'unit', 'redo'],
    store: [
        'api',
        'user',
        'traits',
        'myTraits',
        'myValueTraits',
        'topicsIndex',
        'coursesIndex',
        'currentCourse',
        'audioSources',
        'isPlayingContent',
        'onboardingCompleted',
    ],
    data () {
        return {
            showTranscript: false,
            firstShowTranscript: false,
            showRef: false,
            eventsToCancel: [],
            submissionText: '',

        };
    },
    mounted: function () {
        console.log(`[Get slide] [${this.$f7router.view.name}]`, this.slide.id)
        // this.$f7router.view.name
        // this.$f7router.view.router
        // If the quiz is completed and not redo, go to endpage
        setTimeout(() => {
            if (this.index === 0 && !this.redo && this.unit.completed) {
                for (let i = 0; i < this.unit.slides.length; i++) {
                    const slide = this.unit.slides[i];
                    if (slide.type === 'quizend') {
                        this.$f7router.view.router.navigate(`/units/${this.unit.id}?page=${i}`, {
                            animate: false
                        });
                    }
                }
            }
        }, 150);

        for (let i = 0; i < this.slide.attachments.length; i++) {
            const attach = this.slide.attachments[i];
            if (attach.type === 'answer') {
                this.eventsToCancel.push(`answer:${attach.data.questionId}`);
                this.$events.on(`answer:${attach.data.questionId}`, myAnswer => {
                    // console.log('event', `answer:${attach.data.questionId}`);
                    Vue.set(attach, 'myAnswer', myAnswer);
                });
                if (attach.data.answerType === 'wordcloud') {
                    this.getAttachment(attach);
                }
            } else if (attach.type === 'question' && attach.data.questionType === 'slider') {
                attach.slideId = parseFloat(
                    ((parseFloat(attach.data.max) - parseFloat(attach.data.min)) / 2).toFixed(0)
                );
                if (attach.myAnswer) {
                    attach.slideId = attach.myAnswer.choiceInt;
                }
                if (this.unit.type === 'tracker') attach.slideId = 0;
            }
        }
    },
    beforeDestroy () {
        for (let i = 0; i < this.eventsToCancel.length; i++) {
            this.$events.off(this.eventsToCancel[i]);
        }
    },
    methods: {
        shareResult: function () {
            this.$events.fire('trackEvent', 'share', 'share_quiz_results', this.unit.id, this.unit.name);
            let desc = this.unit.description;
            for (let i = 0; i < this.slide.attachments.length; i++) {
                const attach = this.slide.attachments[i];
                if (attach.type === "answer" && attach.myAnswer
                    && typeof attach.myAnswer.choiceInt !== 'undefined'
                    && attach.data.answers[attach.myAnswer.choiceInt]) {
                    desc = attach.data.answers[attach.myAnswer.choiceInt].title.replace(/(<([^>]+)>)/ig, "");
                }
            }
            utils.shareModule(
                `"${this.unit.name}" ${desc}`,
                desc,
                `/units/${this.unit.id}`,
                'unit',
                this.user.id
            );
        },
        getAttachment: function (attach) {
            this.$http.get(`${this.api}/attachments/${attach.id}`).then(
                response => {
                    Vue.set(attach, 'myAnswer', response.body.myAnswer);
                },
                () => {

                }
            );
        },
        renderText: function (text) {
            // remove already set targets
            text = text.replace(/(<a [^>]*)(target="[^"]*")([^>]*>)/gi, '$1$3');
            // remove already set classes
            text = text.replace(/(<a [^>]*)(class="[^"]*")([^>]*>)/gi, '$1$3');
            // add new target="_blank"
            let destination = pgap ? '_system' : '_blank';
            return text.replace(/(<a [^>]*)(>)/gi, '$1 target="' + destination + '" class="external" $2');
        },
        versionSelector: function () {
            let buttons = [];
            for (let i = 0; i < this.unit.versions.length; i++) {
                const v = this.unit.versions[i];
                if (v.published) {
                    buttons.push({
                        text: v.versionName,
                        onClick: () => {
                            this.$f7router.view.router.navigate(`/units/${v.id}`, {
                                animate: false,
                                replace: true
                            });
                            if (!pgap && location.hostname !== 'localhost') {
                                window.history.pushState(null, "", `/web/units/${v.id}`);
                            }
                        }
                    });
                }
            }
            f7.dialog
                .create({
                    title: 'Choose your version',
                    text: this.unit.name,
                    buttons,
                    verticalButtons: true
                })
                .open();
        },
        renderSubtitle: function () {
            let subtitle = this.renderUnitType(this.unit.type);
            if (this.coursesIndex[this.unit.courseId] && this.topicsIndex[this.coursesIndex[this.unit.courseId].topicId]) subtitle += ` • ${this.topicsIndex[this.unit.topicId].name}`;
            if (this.coursesIndex[this.unit.courseId]) subtitle += ` • ${this.coursesIndex[this.unit.courseId].name}`;
            return subtitle;
        },
        renderUnitType: function (type) {
            return utils.renderUnitType(type);
        },
        replaceLinks: function (link) {
            if (pgap) return link.replace(/<a\s+href=/gi, '<a target="_system" class="external" href=');
            return link.replace(/<a\s+href=/gi, '<a target="_blank" class="external" href=');
        },
        restartUnit: function () {
            this.$f7router.view.router.navigate(`/units/${this.unit.id}?page=0&redo=1`);
        },
        nextSlide: function (delayed) {
            if (this.index + 1 >= this.unit.slides.length) return;
            this.$events.fire('user-progress', {
                itemId: this.unit.isVersionOf || this.unit.id,
                courseId: this.unit.courseId,
                topicId: this.coursesIndex[this.unit.courseId] ? this.coursesIndex[this.unit.courseId].topicId : 0,
                type: 'unit',
                progress: parseInt(((this.index + 1) / this.unit.slides.length) * 100, 10),
                item: this.unit,
                complete: false
            });
            setTimeout(
                () => {
                    this.$f7router.view.router.navigate(`/units/${this.unit.id}?page=${this.index + 1}`);
                },
                delayed ? 200 : 0
            );
        },
        changeText: function (e) {
            this.submissionText = e.target.value;
        },
        play: function (attach) {
            if (!Audio.playing && (!this.isPlayingContent || this.isPlayingContent.id !== attach.id)) {
                Audio.play();
            } else if (!this.isPlaying && this.isPlayingContent && this.isPlayingContent.id === attach.id) {
                Audio.play();
            } else {
                Audio.pause();
            }
        },
        complete: function (complete, skip) {
            if (this.unit.id === BEGIN_THE_REVOLUTION && !this.onboardingCompleted) {
                window.localStore.setItem('onboardingCompleted', 1);
                this.onboardingCompleted = 1;
                this.$events.fire(`unit-completed-${this.unit.id}`);
            }
            else if (CHANGE_YOUR_LIFE_IDS.includes(this.unit.id) && this.onboardingCompleted < 2) {
                window.localStore.setItem('onboardingCompleted', 2);
                this.onboardingCompleted = 2;
                this.$events.fire(`unit-completed-${this.unit.id}`);
            } else if (this.unit.id === DESIRE_TYPE && this.onboardingCompleted < 2) {
                window.localStore.setItem('onboardingCompleted', 2);
                this.onboardingCompleted = 2;
                this.$events.fire(`unit-completed-${this.unit.id}`);
            }
            this.$events.fire(`unit-next-${this.unit.id}`, complete, skip);
        },
        slideLastAttachHasButtons: function () {
            // check if has buttons on slide
            const attach = this.slide.attachments[this.slide.attachments.length - 1];
            if (!attach) return false;
            if (attach.type === 'question' || attach.type === 'opentext') {
                if (attach.data.questionType !== 'slider') {
                    return true;
                }
            }
            return false;
        },
        trackShowTranscript: function () {
            if (!this.firstShowTranscript) {
                this.$events.fire('trackEvent', 'transcript_show', 'content', this.unit.id, this.unit.name);
                this.firstShowTranscript = true;
            }
        }
    }
};
</script>
<style lang="less">
@import '../css/colors.less';
h1 {
    color: #000;
}
.description {
    font-family: AndesLight;
    font-size: 20px;
    color: #000;
    text-align: center;
    line-height: 24px;
}
.greenTitle {
    color: @coral;
}
.ios .range-bar-active {
    background: @coral;
    opacity: 1;
}
.ios .range-bar {
    background: transparent;
    border-radius: 6px;
    height: 6px;
    background: #efefef;
}
// .ios .range-knob {
//     margin-top: -20px;
//     border-radius: 0px;
//     height: 70px;
//     width: 4px;
//     background: @purple;
//     margin-left: 0px;
//     margin-right: -20px !important;
// }
.currentDisplay {
    position: absolute;
    top: -30px;
    width: 100%;
    text-align: center;
    color: @coral;
}
.center,
.question {
    text-align: center !important;
}
.slide,
.slide .block {
    font-family: AndesBook;
    font-size: 13px;
    color: #000;
    line-height: 24px;
}
.slide {
    background: white;
    text-align: center;
    height: 100%;
    padding: 0px;
    color: #000;
    text-align: center;
    line-height: 26px;
    min-height: 100%;
    .scroll {
        padding-top: 30px;
    }
    .padded {
        padding: 24px 0px 0;
    }
    // padding-top: calc(var(--f7-navbar-height) + env(safe-area-inset-top));
    // }
    // .first {
    //     // padding-bottom: 150px;
    //     .padded {
    //         padding: 24px 24px 0;
    //     }
    // padding-top: calc(var(--f7-navbar-height)+ var(--f7-navbar-large-title-height)+ env(safe-area-inset-top));
    // }
    // &.dark {
    //     background: @green;
    //     .block {
    //     color: white !important;
    //     }
    // }
    &.summary {
        .mainSlideContent {
            color: white;
            background: #ff6e61;
            border: 0px dashed @coral;
            font-size: 20px;
            margin: -20px 0px -1px;
            padding: 24px 44px 34px;
        }
        ul {
            padding-left: 0px !important;
            li {
                list-style-type: none;
            }
        }
        ol {
            padding-left: 20px !important;
        }
        ul li:before {
            /* Unicode bullet symbol */
            content: '\2022 ';
            /* Bullet color */
            color: @coral;
            padding-right: 3px;
            margin-left: -20px;
        }
    }
    .html {
        font-size: 20px;
        line-height: 30px;
        text-align: left;
        margin: 0 auto;
        max-width: 90%;
        text-align: left;
        p {
            margin: 0;
        }
        h3 {
            font-family: Editor-bold;
            // margin-bottom: 0px;
        }
        .ql-align-center {
            text-align: center;
        }
        ul {
            padding-left: 20px;
            text-align: left;
        }
    }
    .ansBars {
        text-align: left;
        padding: 30px 16px;
        position: relative;
    }
    .ansBar {
        position: absolute;
        top: 0px;
        left: 0px;
        background: @coral;
        height: 44px;
        z-index: 9;
    }
    .ansBarLabel {
        position: relative;
        float: left;
        clear: both;
        display: block;
        color: black !important;
        padding: 10px 0px 8px;
        width: 100%;
        margin: 3px auto 0px;
        i {
            vertical-align: middle;
            font-size: 30px;
            padding: 10px;
        }
        span {
            position: relative;
            z-index: 10;
        }
        background: #eee;
    }
}
.theme-dark {
    .slide {
        background: #1c1c1d;
        .html {
            color: white;
        }
        .ansBar {
            background: @coral;
        }
        .ansBarLabel {
            color: white !important;
            background: #ccc;
        }
    }
}
.slideImg {
    width: 100%;
    max-width: 300px;
    min-height: 150px; // prevents jurk
    margin: 20px auto 0;
}
.refOpen {
    position: absolute;
    background: @green;
    color: white;
    bottom: 75px;
    right: 0px;
    padding: 10px;
    border-bottom-left-radius: 16px;
    border-top-left-radius: 16px;
    z-index: 10001;
    i {
        font-size: 20px;
    }
}
.minorButton {
    color: gray !important;
    padding: 5px 10px;
    border: 1px solid #efefef;
    border-radius: 10px;
    margin: 10px;
    display: inline-block;
}
.rotate {
    transform: rotate(180deg);
}
.wordcloud {
    font-size: 30px;
    text-transform: uppercase;
    padding: 12px;
    display: inline-block;
    color: @coral;
}
.wavies > use {
    animation: waveAround 120s linear infinite;
    &:nth-child(1) {
        animation-delay: -2s;
    }
    &:nth-child(2) {
        animation-delay: -2s;
        animation-duration: 180s;
    }
    &:nth-child(3) {
        animation-delay: -4s;
        animation-duration: 60s;
    }
}

@keyframes waveAround {
    0% {
        transform: translate(-90px, 0%);
    }
    100% {
        transform: translate(85px, 0%);
    }
}

.wavies-container {
    width: 100%;
    background-color: white;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
}
.theme-dark {
    .wavies-container {
        background-color: #1c1c1d;
    }
}
</style>
